import './App.css';
import './responsive.css';
import './landing.css';
import { ConfigProvider } from 'antd';
import XpressRouter from './router/routes';
import { Fragment } from 'react/jsx-runtime';
import NotificationProvider from './lib/NotificationProvider';
import ConfirmProvider from './lib/ConfirmProvider';

const App1 = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontSize: 12,
        },
      }}
      direction="ltr"
      notification={{}}
    >
      <Fragment>
        <NotificationProvider />
        <ConfirmProvider />
        <XpressRouter />
      </Fragment>
    </ConfigProvider>
  );
};

export default App1;
